import {get, post, put, del, uploadFile, exportExcel} from "./http";
import {BaseUrlNew} from "./NewSiteUrl";
import { headerDemo } from "./editHeader";

// ++++++++++ 橱窗商品 ++++++++++

// 新增橱窗商品
export const postAddGoodsWindow = params =>post( BaseUrlNew + "/api/brandBusiness/addGoodsWindow",params, headerDemo, 1, '4.0');
// 编辑橱窗商品
export const putEditGoodsWindow = params =>put( BaseUrlNew + "/api/brandBusiness/editGoodsWindow",params, headerDemo, 1, '4.0');
// 橱窗商品详情
export const getGoodsWindowDetails = params =>get( BaseUrlNew + "/api/brandBusiness/goodsWindowDetails",params, 1, '4.0');
// 橱窗商品列表
export const getGoodsWindowList = params =>get( BaseUrlNew + "/api/brandBusiness/goodsWindowList",params, 1, '4.0');
// 设置列表推荐
export const selSpread = params =>put( BaseUrlNew + "/api/brandBusiness/setRecommend",params, headerDemo, 1, '4.0');
//品牌店铺-获取店铺视图列表
export const getShopPageList = params =>get( BaseUrlNew + "/api/brandBusiness/viewList",params, 1, '4.0');
//品牌店铺-新增店铺视图
export const addShopPage = params =>post( BaseUrlNew + "/api/brandBusiness/addView",params, headerDemo,1, '4.0');
//品牌店铺-修改店铺视图
export const editShopPage = params =>put( BaseUrlNew + "/api/brandBusiness/editView",params, headerDemo,1, '4.0');
//品牌店铺-删除店铺视图
export const deleteShopPage = params =>del( BaseUrlNew + "/api/brandBusiness/delView",params,1, '4.0');

// 搜索全部橱窗商品
export const getSearchWindowsGoods = params =>get( BaseUrlNew + "/api/brandBusiness/searchWindowsGoods",params, 1, '1.0');
// 商品排序
export const putSetSort = params =>put( BaseUrlNew + "/api/brandBusiness/setSort",params, headerDemo, 1);
// 店铺商品批量排序
export const goodssetsort = params =>post( BaseUrlNew + "/api/brandBusiness/goods/setsort",params, headerDemo,1, '1.0');
// 获取店铺商品所有分类集合
export const getshoptaglist = params =>get( BaseUrlNew + "/api/goodstag/getshoptaglist",params, 1, '1.0');

// 分类管理

// 分页获取店铺商品分类集合
export const getgoodstaglist = (params, shopId) =>get( BaseUrlNew + "/api/goodstag/getlist/" + shopId, params, 1);
// 新增店铺商品分类
export const addgoodstag = params =>post( BaseUrlNew + "/api/goodstag/add",params, headerDemo,1, '1.0');
// 获取店铺商品分类详情
export const getgetinfo = (params, shopId, tagId) =>get( BaseUrlNew + "/api/goodstag/getinfo/" + shopId +'/'+ tagId,params, 1);
// 编辑店铺商品分类
export const editgoodstag = params =>post( BaseUrlNew + "/api/goodstag/edit",params, headerDemo,1, '1.0');
// 删除店铺商品分类
export const delgoodstag = params =>post( BaseUrlNew + "/api/goodstag/del",params, headerDemo,1, '1.0');


// ++++++++++ 扩展信息 ++++++++++

// 品牌店-获取扩展信息
export const getExtendInfo = params =>get( BaseUrlNew + "/api/brandBusiness/extendInfo",params, 1, '4.0');
// 品牌店-修改店铺扩展信息
export const putEditExtendInfo = params =>put( BaseUrlNew + "/api/brandBusiness/editExtendInfo",params, headerDemo, 1, '4.0');

// 获取装修公司施工方式
export const getBbBearRangr = params =>get( BaseUrlNew + "/api/brandBusiness/getBbBearRangr",params, 1, '1.0');
// 获取整装商品单位
export const getUnit = params =>get( BaseUrlNew + "/api/brandBusiness/unit",params, 1, '1.0');
// 获取品牌商商品类型
export const goodsType = params =>get( BaseUrlNew + "/api/brandBusiness/goodsType",params, 1, '1.0');


// 店铺可过滤的店铺列表
export const canFilterShop = params =>get( BaseUrlNew + "/api/brandBusiness/canFilterShop",params, 1, '1.0');
// 店铺已过滤的店铺列表
export const searchShop = params =>get( BaseUrlNew + "/api/brandBusiness/filterShop",params, 1, '1.0');
// 保存店铺过滤店铺
export const shopFilterShop = params =>post( BaseUrlNew + "/api/brandBusiness/shopFilterShop",params, headerDemo,1, '1.0');


// ++++++++++ 收款设置 ++++++++++

// 开户银行（弹框）
export const getBanking = params =>get( BaseUrlNew + "/api/weChatServerPay/banking",params, 1, '1.0');
// 支行列表
export const getBranches = params =>get( BaseUrlNew + "/api/weChatServerPay/branches",params, 1, '1.0');
// 获取省份
export const getProvinces = params =>get( BaseUrlNew + "/api/weChatServerPay/provinces",params, 1, '1.0');
// 获取城市
export const getCities = params =>get( BaseUrlNew + "/api/weChatServerPay/cities",params, 1, '1.0');
// 保存草稿
export const postSaveDemo = params =>post( BaseUrlNew + "/api/weChatServerPay/saveDemo",params, headerDemo,1, '1.0');
// 收款设置详情-回显
export const getSeeDetails = params =>get( BaseUrlNew + "/api/weChatServerPay/details",params, 1, '1.0');
// 提交申请
export const postSubmit = params =>post( BaseUrlNew + "/api/weChatServerPay/submit",params, headerDemo,1, '1.0');

// 企业下是否有店铺
export const getHasShop = params =>get( BaseUrlNew + "/api/enterprise/hasShop",params, 1, '1.0');


// ++++++++++ 收款管理 ++++++++++

// 获取收款设置状态列表
export const collectionsettingGetstatuslist = params =>get( BaseUrlNew + "/api/collectionsetting/getstatuslist",params, 1, '1.0');
// 分页获取收款设置列表
export const collectionsettingGetlist = params =>post( BaseUrlNew + "/api/collectionsetting/getlist",params, headerDemo,1, '1.0');


// ++++++++++ 到店有礼 ++++++++++

// 到店有礼-回显
export const getStoreGift = params =>get( BaseUrlNew + "/api/brandBusiness/storeGift",params, 1, '1.0');
// 修改到店有礼
export const putStoreGift = params =>put( BaseUrlNew + "/api/brandBusiness/storeGift",params, headerDemo, 1, '1.0');


// ++++++++++ 设计师-基本信息 ++++++++++

// 新增设计师基础信息
export const addinfo = params =>post( BaseUrlNew + "/api/designer/addinfo",params, headerDemo,1, '1.0');
// 查询设计师详细信息
export const getinfo = params =>get( BaseUrlNew + "/api/designer/getinfo",params, 1, '1.0');
// 更新设计师基础信息
export const updateinfo = params =>post( BaseUrlNew + "/api/designer/updateinfo",params, headerDemo,1, '1.0');

//修改、新增店铺主页
export const NewEditBBBaseInfo = params =>put( BaseUrlNew + "/api/brandBusiness/editHome",params, headerDemo, 1, '4.0');
//新接口店铺主页详情查询
export const NewSelectBBShopDetailById = params =>get( BaseUrlNew + "/api/brandBusiness/home",params, 1, '4.0');


// ++++++++++ 装修案例 ++++++++++

// 获取装修公司店铺列表
export const getshoplist = (params,userId) =>get( BaseUrlNew + "/api/experience/getshoplist/"+userId,params, 1, '1.0');
// 分页获取装修公司案例集合
export const postgetlist = params =>post( BaseUrlNew + "/api/experience/getlist",params, headerDemo,1, '1.0');
// 获取装修案例详情
export const getzxalinfo = (params, shopId, expId) =>get( BaseUrlNew + "/api/experience/getinfo/" + shopId +'/'+ expId,params, 1);
// 保存装修案例(新增、修改)
export const postsavezxal = params =>post( BaseUrlNew + "/api/experience/save",params, headerDemo,1, '1.0');
// 获取店铺设计师列表
export const designergetlist = (params,shopId) =>get( BaseUrlNew + "/api/designer/getlist/"+shopId,params, 1, '1.0');


// ++++++++++ 幸运购活动 ++++++++++

// 获取列表页面数据
export const postGetOyGoodsList = params => post(BaseUrlNew + '/web/oy-goods/getOyGoodsList', params, headerDemo, 1);
// 新增活动
export const postSaveOyGoods = params =>post( BaseUrlNew + "/web/oy-goods/saveOyGoods",params, headerDemo, 1);
// 查看活动
export const seeGetOyGoods = (params, flexibleCode) =>post( BaseUrlNew + "/web/oy-goods/getOyGoods/" + flexibleCode, params, headerDemo, 1);
// 修改活动
export const modifyEditOyGoods = params =>post( BaseUrlNew + "/web/oy-goods/editOyGoods",params, headerDemo, 1);
// 删除活动
export const deleteDelOyGoods = (params, flexibleCode) =>post( BaseUrlNew + "/web/oy-goods/delOyGoods/" + flexibleCode, params, headerDemo, 1);
// 发布
export const releasePublishOyGoods = (params, flexibleCode) =>post( BaseUrlNew + "/web/oy-goods/publishOyGoods/1/" + flexibleCode, params, headerDemo, 1);
// 下线
export const offlinePublishOyGoods = (params, flexibleCode) =>post( BaseUrlNew + "/web/oy-goods/publishOyGoods/2/" + flexibleCode, params, headerDemo, 1);
// 复制活动
export const copyOyGoods = (params, flexibleCode) =>post( BaseUrlNew + "/web/oy-goods/copyOyGoods/" + flexibleCode, params, headerDemo, 1);
// 查看参与人信息
export const getGoodsPastInfo = params =>post( BaseUrlNew + "/web/oy-goods/getGoodsPastInfo",params, headerDemo, 1);
// 开奖
export const drawLottery = (params, newBoolean, flexibleCode) =>post( BaseUrlNew + "/web/oy-goods/lottery/" + newBoolean +'/'+ flexibleCode, params, headerDemo, 1);
// 获取中奖人数据
export const getWinner = (params, flexibleCode) =>post( BaseUrlNew + "/web/oy-goods/getLotteryGoodsPastInfo/" + flexibleCode, params, headerDemo, 1);
// 派奖
export const postSendPrize = (params, flexibleCode) =>post( BaseUrlNew + "/web/oy-goods/sendAprize/" + flexibleCode, params, headerDemo, 1);
// 其他状态-查看活动-头部统计
export const getOyGoodsInfo = (params, flexibleCode) =>post( BaseUrlNew + "/web/oy-goods/getOyGoodsInfo/" + flexibleCode, params, headerDemo, 1);
// 其他状态-查看活动-列表
export const getGoodsPastList = params =>post( BaseUrlNew + "/web/oy-goods/getGoodsPastList",params, headerDemo, 1);
// 其他状态-查看活动-下载
export const getExcel = (params, flexibleCode) =>exportExcel( BaseUrlNew + "/web/oy-goods/get/excel/" + flexibleCode, params, headerDemo, 1);

// 获取抽奖参与人员集合
export const getplayer = (params, type, businessId) =>get( BaseUrlNew + "/api/lottery/getplayer/" + type +'/'+ businessId,params, 1);
// 获取中奖信息列表
export const getwinners = (params, type, businessId) =>get( BaseUrlNew + "/api/lottery/getwinners/" + type +'/'+ businessId,params, 1);
// 保存奖品信息并抽奖
export const postlottery = params =>post( BaseUrlNew + "/api/lottery",params, headerDemo, 1);

// 获取抽奖参与者取数范围配置
export const getplayerrange = (params, type, businessId) =>get( BaseUrlNew + "/api/lottery/config/playerrange/" + type +'/'+ businessId,params, 1);
// 保存抽奖参与者取数范围配置
export const postplayerrangesave = params =>post( BaseUrlNew + "/api/lottery/config/playerrange/save",params, headerDemo, 1);


/** 积分商城api **/

// 获取基础数据
export const getBaseDataList = params =>get("/BaseDataNew/BaseDataNew/GetBaseDataList",params);
export const GetIntergralGoodsListByCondition = params => post('/IntegralMall/IntegralGoods/GetIntergralGoodsListByCondition', params);
// 新增积分商品
export const InsertIntegralGoods = params => post('/IntegralMall/IntegralGoods/InsertIntegralGoods', params);
// 编辑积分商品
export const UpdateIntegralGoods = params => post('/IntegralMall/IntegralGoods/UpdateIntegralGoods', params);
export const GetIntegralGoodsById = params => post('/IntegralMall/IntegralGoods/GetIntegralGoodsById', params);
export const GetIntegralExchangeRecordList = params => post('/IntegralMall/IntegralGoods/GetIntegralExchangeRecordList', params);
export const BatchModifyIntegralGoodsIsOnSale = params => post('/IntegralMall/IntegralGoods/BatchModifyIntegralGoodsIsOnSale', params);
export const GetSortedIntegralGoodsList = params => post('/IntegralMall/IntegralGoods/GetSortedIntegralGoodsList', params);
export const GetCascadeBrandBusinessModel = params => post('/IntegralMall/IntegralGoods/GetCascadeBrandBusinessModel', params);
export const GetCascadeBrandBusinessCouponModel = params => post('/IntegralMall/IntegralGoods/GetCascadeBrandBusinessCouponModel', params);
// 查询城市下有效店铺
export const getShopByCIty = params => get(BaseUrlNew + '/api/brandBusiness/shopByCIty', params, 1, '1.0');
// 获取店铺代理品类
export const getShopBrandType = params => get(BaseUrlNew + '/api/brandBusiness/shopBrandType', params, 1, '1.0');
// 获取店铺代理品牌
export const getShopBrand = params => get(BaseUrlNew + '/api/brandBusiness/shopBrand', params, 1, '1.0');
// 获取店铺品类品牌下所有商品
export const getShopBrandGoods = params => get(BaseUrlNew + '/api/brandBusiness/shopBrandGoods', params, 1, '1.0');


// 积分规则
export const GetIntergralRuleList = params => post('/IntegralMall/IntegralRule/GetIntergralRuleList', params);
export const OpenOrClozeIntergralRule = params => post('/IntegralMall/IntegralRule/OpenOrClozeIntergralRule', params);
export const SetIntergralClearRule = params => post('/IntegralMall/IntegralRule/SetIntergralClearRule', params);
export const UpdateIntergralRule = params => post('/IntegralMall/IntegralRule/UpdateIntergralRule', params);


// 积分兑换
export const IntegralExchangeOrderRecord = params => post('/IntegralMall/IntegralExchangeOrderRecord/GetIntegralExchangeRecordList', params);
export const UpdateExchangeOrderLogisticsInfo = params => post('/IntegralMall/IntegralExchangeOrderRecord/UpdateExchangeOrderLogisticsInfo', params);
export const GetIntegralExchangeRecordListById = params => post('/IntegralMall/IntegralExchangeOrderRecord/GetIntegralExchangeRecordListById', params);


// ++++++++++ 直播开通审核 ++++++++++

// 查询直播申请列表
export const getAppliedLive = params =>get( BaseUrlNew + "/api/mpbroadcast/applied-live",params, 1, '2.0');
// 直播申请审核
export const putReviewApplication = params =>put( BaseUrlNew + "/api/mpbroadcast/review-application",params, headerDemo, 1, '2.0');
// 编辑关联
export const mpbroadcastEdit = params =>put( BaseUrlNew + "/api/mpbroadcast/edit",params, headerDemo, 1, '1.0');
// 编辑关联（回显）
export const getRelation = params =>get( BaseUrlNew + "/api/mpbroadcast/relation",params, 1, '1.0');
// 驳回直播申请
export const putRejectLive = params =>put( BaseUrlNew + "/api/mpbroadcast/rejectLive",params, headerDemo, 1, '1.0');
// 批量删除直播申请
export const deleteMpbroadcast = params =>del( BaseUrlNew + "/api/mpbroadcast",params, 1, '2.0');


// ++++++++++ 店铺数据 ++++++++++

// 店铺扫码记录列表
export const getDpsjShopRecord = params =>get( BaseUrlNew + "/api/brandBusiness/shopRecord",params, 1, '1.0');
// 员工分享获客记录列表
export const getDpsjOtherRecord = params =>get( BaseUrlNew + "/api/brandBusiness/otherRecord",params, 1, '1.0');
// 店铺浏览数据列表
export const getUserReadList = params =>get( BaseUrlNew + "/api/brandBusiness/userReadList",params, 1, '1.0');
// 店铺浏览数据明细
export const getUserReadDetailedList = params =>get( BaseUrlNew + "/api/brandBusiness/userReadDetailedList",params, 1, '1.0');
// 店铺浏览数据-全部
export const browseListAll = params =>get( BaseUrlNew + "/api/ppc/customer/getlist",params, 1, '1.0');
// 店铺浏览数据-没有付费
export const browseListNo = params =>get( BaseUrlNew + "/api/ppc/browseListNo",params, 1, '1.0');
// 来源渠道
export const getSource = params =>get( BaseUrlNew + "/api/ppc/getSource",params, 1, '1.0');
// 客户属性
export const getAttrib = params =>get( BaseUrlNew + "/api/ppc/getAttrib",params, 1, '1.0');
// 浏览数据-浏览详情
export const browseDetailedList = params =>get( BaseUrlNew + "/api/ppc/browseDetailedList",params, 1, '1.0');
// 购买客户
export const browseBuy = params =>post( BaseUrlNew + "/api/ppc/browseBuy",params, headerDemo, 1, '1.0');
// 查看用户手机号
export const seeCustomerPhone = params =>get( BaseUrlNew + "/api/ppc/seeCustomerPhone",params, 1, '1.0');


// ++++++++++ 施工管理 ++++++++++

// 施工人员添加
export const postInsertConstructionPersonnel = params => post("/Construction/ConstructionPersonnel/InsertConstructionPersonnel", params,'formdata');
// 施工人员列表
export const getSelectConstructionPersonnelList = params => post("/Construction/ConstructionPersonnel/ConstructionPersonnelList", params);
// 施工人员详情
export const postConstructionPersonnelDetailById = params => post("/Construction/ConstructionPersonnel/ConstructionPersonnelDetailById", params);
// 施工人员修改
export const editConstructionPersonnel = params => post("/Construction/ConstructionPersonnel/EditConstructionPersonnel", params,'formdata');
// 施工人员上下架
export const constructionIsOnline = params => post("/Construction/ConstructionPersonnel/ConstructionIsOnline", params);

// 施工工艺添加
export const addConstructionTechnology = params =>post( BaseUrlNew + "/api/construction/addConstructionTechnology",params, headerDemo, 1, '1.0');
// 施工工艺列表
export const constructionTechnologyList = params =>post( BaseUrlNew + "/api/construction/constructionTechnologyList",params, headerDemo, 1, '1.0');
// 施工工艺修改详情
export const constructionTechnologyUpdateDetails = params =>get( BaseUrlNew + "/api/construction/constructionTechnologyUpdateDetails",params, 1, '1.0');
// 施工工艺修改
export const updateConstructionTechnology = params =>post( BaseUrlNew + "/api/construction/updateConstructionTechnology",params, headerDemo, 1, '1.0');
// 施工工艺删除
export const deleteConstructionTechnology = (params, newId) =>del( BaseUrlNew + "/api/construction/deleteConstructionTechnology?id=" + newId, params, 1, '1.0');
// 根据用户获取装修公司
export const getCompanyUser = params =>get( BaseUrlNew + "/api/construction/getCompanyUser",params, 1, '1.0');

// ++++++++++ 付费推广 ++++++++++

// 获取店铺品类付费推广价格
export const getBrandTypePrice = params =>get( BaseUrlNew + "/api/PaidPromotion/brandTypePrice",params, 1, '1.0');
// 充值信息添加
export const postAddRechargeTable = params =>post( BaseUrlNew + "/api/ppc/addRechargeTable",params, headerDemo, 1, '1.0');
// 获取付费推广充值状态
export const rechargeState = params =>get( BaseUrlNew + "/api/ppc/rechargeState",params, 1, '1.0');
// 是否充值成功
export const isrecharge = params =>get( BaseUrlNew + "/api/task/isrecharge",params, 1, '1.0');
// 充值次数下拉选择列表
export const getGrade = params =>get( BaseUrlNew + "/api/ppc/getGrade",params, 1, '1.0');
// 有效客户认定规则添加
export const postAddRecognitionRules = params =>post( BaseUrlNew + "/api/ppc/addRecognitionRules",params, headerDemo, 1, '1.0');
// 充值信息列表
export const getRechargeTable = params =>get( BaseUrlNew + "/api/ppc/getRechargeTable",params, 1, '1.0');
// 充值信息统计
export const getRechargeTotal = params =>get( BaseUrlNew + "/api/ppc/getRechargeTotal",params, 1, '1.0');
// 店铺推广规则信息详情
export const recognitionRulesDetails = params =>get( BaseUrlNew + "/api/ppc/recognitionRulesDetails",params, 1, '1.0');
// 付费推广退款
export const paidPromotionRefund = (params, newId) =>post( BaseUrlNew + "/api/weChatServerPay/paidPromotionRefund?id=" + newId,params, headerDemo, 1, '1.0');
// 查看已付费推广客户列表
export const getDeduction = params =>get( BaseUrlNew + "/api/ppc/getDeduction",params, 1, '1.0');
// 获取店铺任务列表集合
export const postshoptask = params =>post( BaseUrlNew + "/api/task/shoptask",params, headerDemo, 1, '1.0');
// 获取店铺任务消耗记录集合
export const postconsume = params =>post( BaseUrlNew + "/api/task/shoptask/consume",params, headerDemo, 1, '1.0');

// ++++++++++ 数据 ++++++++++

// 获取活动报名人员列表
export const signupGetlist = params =>post( BaseUrlNew + "/api/activity/signup/getlist",params, headerDemo, 1, '1.0');
// 导出活动报名人员列表
export const getlistExport = (params,activityId) =>exportExcel( BaseUrlNew + "/api/activity/signup/getlist/export/"+activityId,params, 1);
// 活动订单列表
export const getActivityOrder = params =>get( BaseUrlNew + "/api/activity/activityOrder",params, 1, '1.0');
// 导出活动订单记录
export const getActivityOrderRecordToExcel = params => exportExcel( BaseUrlNew + "/api/activity/activityOrderRecordToExcel", params);
// 活动带客（单）列表
export const getShopHelpCustomersToShop = params =>get( BaseUrlNew + "/api/activity/shopHelpCustomersToShop",params, 1, '1.0');
// 导出活动带客（单）记录
export const getShopHelpCustomersToShopToExcel = params => exportExcel( BaseUrlNew + "/api/activity/shopHelpCustomersToShopToExcel", params);
// 活动到店打卡礼记录列表
export const getToStoreRecord = params =>get( BaseUrlNew + "/api/activity/toStoreRecord",params, 1, '1.0');
// 导出到店打卡礼记录
export const getToStoreRecordToExcel = params => exportExcel( BaseUrlNew + "/api/activity/toStoreRecordToExcel", params);
// 活动到店打卡礼记录明细
export const getToStoreRecordDetails = params =>get( BaseUrlNew + "/api/activity/toStoreRecordDetails",params, 1, '1.0');
// 活动连单礼记录列表
export const getContinuityOrderRecord = params =>get( BaseUrlNew + "/api/activity/continuityOrderRecord",params, 1, '1.0');
// 导出活动连单礼记录
export const getContinuityOrderRecordToExcel = params => exportExcel( BaseUrlNew + "/api/activity/continuityOrderRecordToExcel", params);
// 活动连单礼记录明细
export const getActivityContinuityOrderDetails = params =>get( BaseUrlNew + "/api/activity/activityContinuityOrderDetails",params, 1, '1.0');

// ++++++++++ 客源大厅 ++++++++++

// 获取客源大厅列表
export const oldsellgetlist = params =>post( BaseUrlNew + "/api/clue/sell/getlist",params, headerDemo, 1, '1.0');
export const newsellgetlist = (params,type,id) =>post( BaseUrlNew + "/api/clue/sell/pool/"+type+'/'+id,params, headerDemo, 1, '1.0');
// 检查客户需求是否完成支付
export const sellispaid = (params,shopId,cucctrId) =>get( BaseUrlNew + "/api/clue/sell/ispaid/"+shopId+'/'+cucctrId,params, 1);
// 客户需求状态变更（申请退款、(不)同意退款）
export const orderchangestatus = params =>post( BaseUrlNew + "/api/clue/order/changestatus",params, headerDemo, 1, '1.0');
// 获取客户电话（绑定虚拟号）
export const bindphone = params =>post( BaseUrlNew + "/api/clue/virtualnumber/bind",params, headerDemo, 1, '3.0');
// 获取虚拟号通话记录（含通话录音）
export const callrecordlist = params =>post( BaseUrlNew + "/api/clue/virtualnumber/callrecord/getlist",params, headerDemo, 1, '1.0');
// 获取客户需求跟进记录列表
export const getfollowuplist = params =>post( BaseUrlNew + "/api/clue/order/getfollowuplist",params, headerDemo, 1, '1.0');
// 新增客户需求跟进记录
export const addfollowup = params =>post( BaseUrlNew + "/api/clue/order/addfollowup",params, headerDemo, 1, '1.0');
// 虚拟账户购买客户需求
export const cluebuy = (params,businessType,businessId) =>post(
    BaseUrlNew + "/api/clue/buy/" + businessType +'/'+ businessId,params, headerDemo, 1, '1.0');
// 获取订单退款信息
export const refundinfo = (params,orderId) =>get( BaseUrlNew + "/api/clue/order/refundinfo/"+orderId,params, 1);

// ++++++++++ 退款审核 ++++++++++

// 获取客户退款审核列表
export const getauditlist = params =>post( BaseUrlNew + "/api/clue/order/getauditlist",params, headerDemo, 1, '1.0');
// 获取黑名单配置
export const getconfig = params =>get( BaseUrlNew + "/api/clue/blacklist/getconfig",params, 1, '1.0');
// 保存黑名单配置
export const saveconfig = params =>post( BaseUrlNew + "/api/clue/blacklist/saveconfig",params, headerDemo, 1, '1.0');
// 获取黑名单列表
export const blacklistgetlist = params =>post( BaseUrlNew + "/api/clue/blacklist/getlist",params, headerDemo, 1, '1.0');
// 移除黑名单
export const blacklistremove = params =>post( BaseUrlNew + "/api/clue/blacklist/remove",params, headerDemo, 1, '1.0');

// ++++++++++ 导入客户管理 ++++++++++

// 获取创客客户列表
export const usercustomergetlist = params =>post( BaseUrlNew + "/api/clue/statistics/usercustomer/getlist",params, headerDemo, 1, '1.0');
// 获取客户售卖记录列表
export const getsellrecord = params =>post( BaseUrlNew + "/api/clue/statistics/usercustomer/getsellrecord",params, headerDemo, 1, '1.0');
// 获取客户需求销售记录集合
export const shopcustomercluegetlist = params =>post( BaseUrlNew + "/api/clue/statistics/shopcustomerclue/getlist",params, headerDemo, 1, '1.0');
// 【创客黑名单】获取创客列表(包含黑名单数据)
export const djhmdpostlist = params =>post( BaseUrlNew + "/api/clue/seller/blacklist/getlist",params, headerDemo, 1, '1.0');
// 【创客黑名单】设置/取消黑名单
export const qxdjhmd = params =>post( BaseUrlNew + "/api/clue/seller/blacklist/set",params, headerDemo, 1, '1.0');
// 客户需求数据字典
export const cluegettypes = params =>get( BaseUrlNew + "/api/clue/gettypes",params, 1, '1.0');
// 获取客源详细信息
export const customergetinfo = (params,customerId) =>get(BaseUrlNew + "/api/clue/customer/getinfo/"+customerId,params, 1);
// 把客户需求或客户设为无效
export const customerchan = params =>post( BaseUrlNew + "/api/clue/customer/change",params, headerDemo, 1, '1.0');

// ++++++++++ 客源变现 ++++++++++

// 客源变现-全部客户
export const shopcustomergetlist = params =>post( BaseUrlNew + "/api/clue/statistics/shopcustomer/getlist",params, headerDemo, 1, '1.0');
// 客源变现-销售记录
export const shopordergetlist = params =>post( BaseUrlNew + "/api/clue/statistics/shoporder/getlist",params, headerDemo, 1, '1.0');


// ++++++++++ 资金管理 ++++++++++

// 获取所有虚拟户列表
export const getalllist = params =>post( BaseUrlNew + "/api/vmaccount/getalllist",params, headerDemo, 1, '1.0');
// 更新虚拟账户状态(停用/启用)
export const chnagestatus = (params,businessType,businessId) =>post(
    BaseUrlNew + "/api/vmaccount/chnagestatus/" + businessType +'/'+ businessId,params, headerDemo, 1, '1.0');
// 获取客户资源统计数据
export const statisticsgetlist = params =>post( BaseUrlNew + "/api/clue/statistics/getlist",params, headerDemo, 1, '1.0');
// 获取用户资金账户统计信息
export const userstatistics = params =>post( BaseUrlNew + "/api/moneyaccount/user/statistics",params, headerDemo, 1, '1.0');
// 获取合伙人资金账户统计信息
export const partnerstatistics = params =>post( BaseUrlNew + "/api/moneyaccount/partner/statistics",params, headerDemo, 1, '1.0');
// 获取平台账户充值记录
export const rechargerecordgetlist = params =>post( BaseUrlNew + "/api/moneyaccount/rechargerecord/getlist",params, headerDemo, 1, '1.0');
// 新增平台账户充值记录
export const rechargerecordadd = params =>post( BaseUrlNew + "/api/moneyaccount/rechargerecord/add",params, headerDemo, 1, '1.0');


// ++++++++++ 店铺钱包 ++++++++++

// 获取虚拟账户详情
export const vmaccountgetinfo = (params,businessType,businessId) =>get(
    BaseUrlNew + "/api/vmaccount/getinfo/"+businessType+'/'+businessId,params, 1);
// 获取虚拟账户交易记录列表
export const vmaccountgetlist = (params,businessType,businessId) =>post(
    BaseUrlNew + "/api/vmaccount/getlist/" + businessType +'/'+ businessId,params, headerDemo, 1, '1.0');
// 获取虚拟账户交易详情
export const vmaccountgetdetail = (params,businessType,businessId,tradeCode) =>get(
    BaseUrlNew + "/api/vmaccount/getdetail/"+businessType+'/'+businessId+'/'+tradeCode,params, 1);
// 获取虚拟账户余额
export const vmaccountgetbalance = (params,businessType,businessId) =>get(
    BaseUrlNew + "/api/vmaccount/getbalance/"+businessType+'/'+businessId,params, 1);
// 查询充值单状态
export const vmaccountisrecharge = (params,rid) =>get( BaseUrlNew + "/api/vmaccount/isrecharge/"+rid,params, 1);
// 虚拟账户余额提现
export const vmaccountwithdraw = (params,businessType,businessId) =>post(
    BaseUrlNew + "/api/vmaccount/withdraw/" + businessType +'/'+ businessId,params, headerDemo, 1, '1.0');
// 获取店铺收款人手机号
export const getpayee = (params,shopId) =>get(BaseUrlNew + "/api/shop/getpayee/"+shopId,params, 1);
// 设置店铺收款人手机号
export const setpayee = (params,shopId) =>post(BaseUrlNew + "/api/shop/setpayee/" + shopId,params, headerDemo, 1, '1.0');
//获取微信配置
export const weChatServerPaygetconfig = params =>get( BaseUrlNew + "/api/weChatServerPay/getconfig",params, 1, '1.0');



// ++++++++++ 微信账户 ++++++++++

//获取微信交易账户列表
export const tradeaccountgetlist = params =>get( BaseUrlNew + "/api/tradeaccount/getlist",params, 1, '1.0');
// 获取微信账户收支明细列表
export const tradedetailgetlist = (params,id) =>get(BaseUrlNew + "/api/tradeaccount/tradedetail/getlist/"+id,params, 1);
//获取微信账户交易提醒列表
export const noticegetlist = params =>get( BaseUrlNew + "/api/tradeaccount/notice/getlist",params, 1, '1.0');
//微信交易账户转账（转入/转出）
export const transfer = params =>post( BaseUrlNew + "/api/tradeaccount/transfer",params, 1, '1.0');


// ++++++++++ 交付宝 ++++++++++

// 获取交付宝应用配置
export const configGetinfo = (params,id) =>get(BaseUrlNew + "/api/delivery/config/getinfo/"+id,params, 1);
// 绑定交付宝手机号
export const configBindmobile = params =>post( BaseUrlNew + "/api/delivery/config/bindmobile",params, headerDemo, 1, '1.0');
// 自定义交付宝应用名称
export const configSetname = params =>post( BaseUrlNew + "/api/delivery/config/setname",params, headerDemo, 1, '1.0');
// 获取套餐列表
export const productGetlist = params =>get(BaseUrlNew + "/api/product/getlist",params, 1);
// 获取套餐购买记录列表
export const purchasedGetlist = params =>post( BaseUrlNew + "/api/product/purchased/getlist",params, headerDemo, 1, '1.0');
// 购买套餐
export const productPlaceorder = params =>post( BaseUrlNew + "/api/product/placeorder",params, headerDemo, 1, '1.0');
// 轮询接口
export const orderGetstatus = (params,orderno) =>get(BaseUrlNew + "/api/product/order/getstatus?orderno="+orderno,params, 1);
// 已购套餐退款
export const productRefund = params =>post( BaseUrlNew + "/api/product/refund",params, headerDemo, 1, '1.0');

// 检查是否有试用项目
export const trialCheck = (params,businessType,businessId) =>get(
    BaseUrlNew + "/api/delivery/trial/check/"+businessType+'/'+businessId,params, 1);
// 删除试用项目
export const trialDel = params =>post( BaseUrlNew + "/api/delivery/trial/del",params, headerDemo, 1, '1.0');

// 赠送套餐
export const productfreegift = params =>post( BaseUrlNew + "/api/product/freegift",params, headerDemo, 1, '1.0');


// ++++++++++ 分佣管理 ++++++++++

// 获取佣金类型集合
export const gettypes = params =>get( BaseUrlNew + "/api/brokerageconfig/gettypes",params, 1, '1.0');
// 获取佣金配置列表
export const brokerageconfigList = params =>get( BaseUrlNew + "/api/brokerageconfig/getlist",params, 1, '1.0');
// 根据佣金类型获取配置角色集合
export const getshopgoods = (params,type) =>get( BaseUrlNew + "/api/brokerageconfig/getroles/"+type,params, 1);
// 保存(新增&编辑)佣金配置
export const brokerageconfigSave = params =>post( BaseUrlNew + "/api/brokerageconfig/save",params, headerDemo, 1, '1.0');
// 获取配置详情
export const brokerageconfigInfo = params =>get( BaseUrlNew + "/api/brokerageconfig/getinfo",params, 1, '1.0');


// ++++++++++ 套餐包管理 ++++++++++

// 分页获取产品套餐包列表
export const packagegetlist = params =>get( BaseUrlNew + "/api/product/package/getlist",params, 1, '1.0');
// 获取所有上架的产品和权益
export const getproductlist = params =>get( BaseUrlNew + "/api/product/package/getproductlist",params, 1, '1.0');
// 获取套餐包详情
export const packagegetinfo = (params,pkgId) =>get( BaseUrlNew + "/api/product/package/getinfo/"+pkgId,params, 1, '1.0');
// 创建/编辑套餐包
export const packagesave = params =>post( BaseUrlNew + "/api/product/package/save",params, headerDemo, 1, '1.0');
// 变更产品套餐包上下架状态
export const packagechangestatus = params =>post( BaseUrlNew + "/api/product/package/changestatus",params, headerDemo, 1, '1.0');
// 删除产品套餐包
export const packagedel = params =>post( BaseUrlNew + "/api/product/package/del",params, headerDemo, 1, '1.0');




// ++++++++++ 邀请人变更 ++++++++++

// 分页获取用户列表
export const invitergetlist = params => post(BaseUrlNew + "/api/user/inviter/getlist", params, headerDemo, 1, '1.0')
// 获取创客信息
export const getmakerinfo = params => post(BaseUrlNew + "/api/user/inviter/getmakerinfo", params, headerDemo, 1, '1.0')
// 变更用户邀请人（支持批量操作）
export const inviterchange = params => post(BaseUrlNew + "/api/user/inviter/change", params, headerDemo, 1, '1.0')



// ++++++++++ 精准客户 ++++++++++

// 获取店铺的精准客户列表
export const precisioncustomer = params => post(BaseUrlNew + "/api/precisioncustomer/getlist", params, headerDemo, 1, '1.0')
// 获取精准客户退客审核列表
export const precisioncustomerlist = params => post(BaseUrlNew + "/api/precisioncustomer/getauditlist", params, headerDemo, 1, '1.0')
// 获取店铺的精准客户详情
export const precisioncustomerDet = params => post(BaseUrlNew + "/api/precisioncustomer/getdetail", params, headerDemo, 1, '1.0')
// 精准客户退款审核
export const precisioncustomerAudit = params => post(BaseUrlNew + "/api/precisioncustomer/audit", params, headerDemo, 1, '1.0')
// 精准客户退款
export const precisioncustomerrefund = params => post(BaseUrlNew + "/api/precisioncustomer/refund", params, headerDemo, 1, '1.0')





// ++++++++++ 录音识别配置 ++++++++++

// 录音识别-获取关键字列表
export const keywordconfig = params => post(BaseUrlNew + "/api/virtualnumber/callrecord/keywordconfig/getlist", params, headerDemo, 1, '1.0')
// 录音识别-关键字新增
export const keywordconfiginsert = params => post(BaseUrlNew + "/api/virtualnumber/callrecord/keywordconfig/insert", params, headerDemo, 1, '1.0')
// 录音识别-关键字编辑
export const keywordconfigupdate = params => post(BaseUrlNew + "/api/virtualnumber/callrecord/keywordconfig/update", params, headerDemo, 1, '1.0')
// 录音识别-关键字删除
export const keywordconfigdel = params => post(BaseUrlNew + "/api/virtualnumber/callrecord/keywordconfig/del", params, headerDemo, 1, '1.0')
// 录音识别-获取关键字详情
export const keywordconfiggetinfo = (params, configId) => get(BaseUrlNew +  "/api/virtualnumber/callrecord/keywordconfig/getinfo/" + configId, params, 1)


// WEBPACK FOOTER //
// ./src/api/shopWindow.js